<template>
  <div v-if="active" class="inline-flex flex-row">
    <span v-if="thresh" class="similarity similarity-advice">
      Kompass: {{ score }}
    </span>
    <span v-else="thresh" class="similarity similarity-default">
      Kompass: {{ score }}
    </span>
  </div>
  <div v-else="active" class="inline-flex flex-row">
    <button @click="convert" class="similarity similarity-default">
      Kompass befragen
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const props = defineProps({value: Number});

const router = useRouter();
const store = useStore();

const format = (value) => parseFloat(value * 100).toFixed() + "%";

const parent = computed(() => store.getters['context/context']);
const active = computed(() => parent.value.active);

const score = computed(() => format(props.value));
const thresh = computed(() => props.value >= 0.9);

const convert = () => router.push({
  name: 'podcasts.conversion',
  params: {id: parent.value.id},
});
</script>

<style scoped>
.similarity
{
  @apply rounded-full;
  @apply px-2 py-1;
  @apply text-xs font-medium;
};

.similarity-advice
{
  @apply text-green-800;
  @apply bg-green-100;
};

.similarity-default
{
  @apply text-gray-800;
  @apply bg-gray-200;
};
</style>